import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';
import normBoolean from "../../Form/Normalizer/boolean.js";
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx";
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx";
import Toggle from "../../../../shared/components/Form/Field/Toggle.jsx";
import connectModal from "../../../../shared/components/Modals/connect.js";
import ConfirmModal from "../../../../shared/components/Modals/ConfirmModal/ConfirmModal.jsx";

import './ProfileVisibilityForm.scss'

export const name = 'ProfileVisibilityForm';

class ProfileVisibilityForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldResetForm: false,
      revert:!this.props.initialValues.public
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if(prevState.shouldResetForm !== this.state.shouldResetForm && !!this.state.shouldResetForm){
      this.initialiseForm()
      this.setState({shouldResetForm: false})
    }
  }

  initialiseForm = () => {
    this.props.reset()
  }

  confirmModal = (confirmAction) => {
    this.props.openConfirmModal({
      header: 'Masquer votre profil',
      body: 'Êtes-vous sûr(e) de vouloir masquer votre profil ? Bien entendu, vous pourrez à nouveau qualifier votre profil en public par la suite.',
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
      confirmAction: confirmAction,
      onCancel: () => this.setState({shouldResetForm: true}),
    });
  }
  onFreelancePublicChange = (event, value) => {
    const revert = !value
    if(revert) {
      this.props.handlePublicVisibilityChange(event, revert)
      return
    }
    this.confirmModal(() => this.props.handlePublicVisibilityChange(event, revert)
      .then((response) => {
        if(false === response) {
          this.initialiseForm()
        }})
    )
  }

  render() {
    return (
      <div id={name} className="profile-visibility-form">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            return
          }}
        >
          <CardRow className={'mt-4'} justify="center">
            <CardCol>
              <Field
                name={`freelance.revertPublic`}
                firstLabel={'Profil public'}
                secondLabel={'Profil masqué'}
                icons={false}
                disabled={this.props.disabled}
                normalize={normBoolean}
                component={Toggle}
                onChange={this.onFreelancePublicChange}
              />
            </CardCol>
          </CardRow>
        </form>
      </div>
    );
  }
}

let ReduxProfileVisibilityForm = reduxForm({
  form: name,
})(ProfileVisibilityForm);

export default connectModal({ConfirmModal}, ReduxProfileVisibilityForm)
